import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { FreeLayout, MainLayout } from './layouts';
import { adminRoute, privateAdminRoutes, publicAdminRoutes } from './utils/routes/admin';
import { publicRoutes } from './utils/routes';
import { PrivateRoute } from './components/common';
// Imported by path, not via components/common: they pull in utils/routes, which imports components/common (cycle).
import RoleRoute from './components/common/roleRoute/RoleRoute';
import SetupTab from './components/common/roleRoute/SetupTab';
import SetupHome from './components/common/roleRoute/SetupHome';
import AdminRoute from './components/common/roleRoute/AdminRoute';
import { privateSetupRoutes, setupRoute } from './utils/routes/setup';

type Props = {};

const App = (props: Props) => {
  return (
    <BrowserRouter>
      <Routes>
        <Route path={'/'} element={<Navigate to={`${adminRoute.base}${adminRoute.login}`} />}></Route>
        <Route path={adminRoute.base} element={<Navigate to={`${adminRoute.base}${adminRoute.login}`} />}></Route>

        <Route element={<FreeLayout />}>
          {publicRoutes.map((route, index) => {
            const Page = route.component || '';
            return (
              <Route key={index} path={route.path} element={<Page />}>
                {route.children &&
                  route.children.length > 0 &&
                  route.children.map((childRoute, index) => {
                    const ChildComponent = childRoute.component;
                    return (
                      <Route
                        key={index}
                        path={childRoute.path}
                        index={childRoute.index ?? false}
                        element={<ChildComponent />}
                      />
                    );
                  })}
              </Route>
            );
          })}
        </Route>

        <Route element={<PrivateRoute redirectTo={`${adminRoute.base}${adminRoute.login}`} />}>
          <Route element={<RoleRoute allow={['superAdmin', 'staff']} />}>
          <Route path={adminRoute.base} element={<MainLayout />}>
            {privateAdminRoutes.map((route, index) => {
              const Page = route.component || '';
              return (
                <Route
                  key={index}
                  path={route.path}
                  element={<AdminRoute feature={route.feature} superAdminOnly={route.superAdminOnly} page={<Page />} />}
                >
                  {route.children &&
                    route.children.length > 0 &&
                    route.children.map((childRoute, index) => {
                      const ChildComponent = childRoute.component;
                      return (
                        <Route
                          key={index}
                          path={childRoute.path}
                          index={childRoute.index ?? false}
                          element={<ChildComponent />}
                        />
                      );
                    })}
                </Route>
              );
            })}
          </Route>
          </Route>

          <Route element={<RoleRoute allow={['seniorAdmin', 'otherAdmin']} />}>
            <Route path={setupRoute.base} element={<MainLayout />}>
              <Route index element={<SetupHome />} />
              {privateSetupRoutes.map((route) => {
                const Page = route.component;
                return (
                  <Route
                    key={route.path}
                    path={route.path}
                    element={<SetupTab module={route.module} action={route.action} page={<Page />} />}
                  />
                );
              })}
            </Route>
          </Route>
        </Route>
      </Routes>
    </BrowserRouter>
  );
};

export default App;
